import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { RouterModule } from '@angular/router';
import {
  BinaCatalogCalculatorSidbarComponent,
  BinaCatalogFastSearchListComponent,
  BinaCatalogItemComponent,
  BinaCatalogItemTitleEditSidbarComponent,
  BinaCatalogListComponent,
  BinaCatalogSearchComponent,
  BinaCatalogSearchSidebarComponent,
  BinaCodeItemComponent,
  HtsCodeCardComponent,
} from './components';
import { HtsSuggestionsWithoutCatalogPipe } from './pipes';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
  declarations: [
    BinaCodeItemComponent,
    BinaCatalogItemComponent,
    HtsCodeCardComponent,
    BinaCatalogListComponent,
    BinaCatalogItemTitleEditSidbarComponent,
    BinaCatalogSearchComponent,
    BinaCatalogSearchSidebarComponent,
    BinaCatalogCalculatorSidbarComponent,
    BinaCatalogFastSearchListComponent,
    HtsSuggestionsWithoutCatalogPipe,
  ],
  imports: [
    CommonModule,
    MutualModule,
    TranslateModule,
    PipesSharedModule,
    NgxPaginationModule,
    NzToolTipModule,
    RouterModule,
    FormWrapperModule,
    BsDropdownModule.forRoot(),
  ],
  exports: [
    BinaCodeItemComponent,
    BinaCatalogItemComponent,
    HtsCodeCardComponent,
    BinaCatalogListComponent,
    BinaCatalogItemTitleEditSidbarComponent,
    BinaCatalogSearchComponent,
    BinaCatalogSearchSidebarComponent,
    BinaCatalogCalculatorSidbarComponent,
    BinaCatalogFastSearchListComponent,
    HtsSuggestionsWithoutCatalogPipe,
  ],
})
export class BinaSharedModule {}
